const normalizeName = (str: string): string => str
        .toLocaleLowerCase()
        .replace(/ł/g, 'l')
        .replace(/ó/g, 'o')
        .replace(/ą/g, 'a')
        .replace(/ś/g, 's')
        .replace(/ż/g, 'z')
        .replace(/ź/g, 'z')
        .replace(/ć/g, 'c')
        .replace(/ń/g, 'n')
        .replace(/ę/g, 'e')
        .replace(/\s/g, '');

export default normalizeName;
